export default __webpack_public_path__ + "60120513a5494e6b628743466d95890b.png";